import React from 'react';
interface SectionDividerProps {
  className?: string;
}
export function SectionDivider({
  className = ''
}: SectionDividerProps) {
  return <div className={`flex items-center justify-center py-2 ${className}`} data-id="element-480">
      <div className="watercolor-divider max-w-xs" data-id="element-481" />
    </div>;
}
export function OrnamentDivider({
  className = ''
}: SectionDividerProps) {
  return <div className={`${`flex items-center justify-center gap-4 py-4 ${className}`} pt-[5px] pb-[5px]`} data-id="element-482">
      <div className="h-px flex-1 max-w-24" style={{
      background: 'var(--gold-light)'
    }} data-id="element-483" />
      <span className="text-2xl" style={{
      color: 'var(--gold)'
    }} data-id="element-484">
        ✦
      </span>
      <div className="h-px flex-1 max-w-24" style={{
      background: 'var(--gold-light)'
    }} data-id="element-485" />
    </div>;
}